import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import FrontLayout from "../frontLayout";
import HomePagesComponet from "../frontLayout/pages/home";
import ParochetPagesComponet from "../frontLayout/pages/parochet";
import TorahPagesComponet from "../frontLayout/pages/TorahPagesComponet";
import ChuppaPagesComponet from "../frontLayout/pages/ChuppaPagesComponet";
import BimahPagesComponet from "../frontLayout/pages/BimahPagesComponet";
import BagsPagesComponet from "../frontLayout/pages/BagsPagesComponet";
// import AboutPagesComponet from "../frontLayout/pages/AboutPagesComponet";
import Begin_To_Build_Your_Custom_Beteil from "../frontLayout/pages/Begin_To_Build_Your_Custom_Beteil";
import ColorCombinationProducts from "../frontLayout/pages/ColorCombinationProducts";
// import ProductPage from "../frontLayout/pages/ProductPage";
import Carts from "../frontLayout/pages/Carts";
import CheckoutPage from "../frontLayout/pages/CheckOutPage";
import AuthLayout from "../authLayout";
import SignupComponent from "../authLayout/pages/signup";
import LoginComponent from "../authLayout/pages/login";
import ForgotPasswordComponent from "../authLayout/pages/forgot-password";
import VerificationCodeComponent from "../authLayout/pages/verificationCode";
// import PasswordChangeComponent from "../authLayout/pages/password-change";
// import SelectToCompare from "../frontLayout/pages/SelectToCompare";
import CompareCustomDesign from "../frontLayout/pages/CompareCustomDesign";
import ProductDetail from "../frontLayout/pages/ProductDetail";
import ProductsDetailsPage from "../frontLayout/pages/ProductsDetailsPage";
import ProductsList from "../frontLayout/pages/ProductsList";
import Customize from "../frontLayout/pages/customize";
import Profile from "../frontLayout/pages/Profile";
import ProfileEditPage from "../frontLayout/pages/ProfileEditPage";
import FavProducts from "../frontLayout/pages/FavProducts";
import SavedDesign from "../frontLayout/pages/SavedDesign";
import Track from "../frontLayout/pages/Track";
import AddressPage from "../frontLayout/pages/AddressPage";
import AddAddress from "../frontLayout/pages/AddAddress";
import SettingPage from "../frontLayout/pages/SettingPage";
import ChangePassword from "../frontLayout/pages/ChangePassword";
import AboutUs from "../frontLayout/pages/About/AboutUs";
import OrdersPage from "../frontLayout/pages/OrdersPage";
import Termscondition from "../components/terms&condition";
import Privacy from "../components/Privacy";
import Return from "../components/Return";
import SuccessPage from "../frontLayout/pages/Success";
import CancelPage from "../frontLayout/pages/Cancel";

const Root = () => {
  // -------
  const { pathname } = useLocation();
  // autmaticaly scroll to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // -------
  return (
    <Routes>
      <Route path="" element={<AuthLayout />}>
        <Route exact path="login" element={<LoginComponent />} />
        <Route exact path="signup" element={<SignupComponent />} />
        <Route
          exact
          path="forgot-password"
          element={<ForgotPasswordComponent />}
        />
        <Route
          exact
          path="verification-code"
          element={<VerificationCodeComponent />}
        />
        {/* <Route
          exact
          path="change-password"
          element={<PasswordChangeComponent />}
        /> */}
      </Route>
      <Route path="/" element={<FrontLayout />}>
        <Route exact index element={<HomePagesComponet />} />
        <Route exact path="category" element={<ParochetPagesComponet />} />
        <Route exact path="product" element={<ProductsDetailsPage />} />
        <Route exact path="customize" element={<Customize />} />
        <Route exact path="torah-cover" element={<TorahPagesComponet />} />
        <Route exact path="chuppa" element={<ChuppaPagesComponet />} />
        <Route exact path="success" element={<SuccessPage />} />
        <Route exact path="cancel" element={<CancelPage />} />
        <Route exact path="bimah" element={<BimahPagesComponet />} />
        <Route exact path="bags" element={<BagsPagesComponet />} />
        <Route exact path="about" element={<AboutUs />} />
        <Route exact path="category/collection" element={<ProductsList />} />
        <Route
          exact
          path="category/collection/product-detail"
          element={<ProductsDetailsPage />}
        />
        <Route exact path="profile" element={<Profile />} />
        <Route exact path="return" element={<Return />} />
        <Route exact path="Privacy" element={<Privacy />} />
        <Route exact path="edit" element={<ProfileEditPage />} />
        <Route exact path="favorite" element={<FavProducts />} />
        <Route exact path="terms" element={<Termscondition />} />
        <Route exact path="saved-design" element={<SavedDesign />} />
        <Route exact path="track" element={<Track />} />
        <Route exact path="address" element={<AddressPage />} />
        <Route exact path="orders" element={<OrdersPage />} />
        <Route exact path="Add" element={<AddAddress />} />
        <Route exact path="Add/:id" element={<AddAddress />} />
        <Route exact path="settings" element={<SettingPage />} />
        <Route exact path="change-password" element={<ChangePassword />} />
        <Route
          exact
          path="build_your_custom_beteil/:id"
          element={<Begin_To_Build_Your_Custom_Beteil />}
        >
          <Route
            path="ColorCombinationProducts"
            element={<ColorCombinationProducts />}
          />
          {/* <Route exact path="product" element={<ProductPage />} /> */}
        </Route>
        {/* <Route exact path="product" element={<ProductPage />} /> */}
        <Route exact path="carts" element={<Carts />} />
        {/* <Route path="compare" element={<SelectToCompare />} /> */}
        <Route path="compare" element={<CompareCustomDesign />} />
        <Route path="product_detail/:id" element={<ProductDetail />} />
        <Route exact path="checkout" element={<CheckoutPage />} />
      </Route>
      <Route
        path="*"
        element={
          <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="text-center">
              <img loading="lazy" 
                width={600}
                className="rounded-5"
                src="https://static.vecteezy.com/system/resources/thumbnails/024/217/744/small_2x/design-template-for-web-page-with-404-error-isometric-page-not-working-error-png.png"
                alt=""
              />
              <p className="text-muted fw-semibold fs-14">
                The page you're looking for doesn't exist.
              </p>
              <a
                href="/"
                className="btn p-2 px-4 fs-16 btn-warning fw-bold text-white rounded-5"
              >
                Go Home
              </a>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default Root;
